import { Beds24ReservationStatus, ReservationPlatform, TermsType } from '@gen-common/enums';
import { PeriodRateDTO } from '@gen/periodRate/periodRate.dto';
import { ReservationDTO } from '@gen/reservation/reservation.dto';
import { PlainDateUtil } from './plain-date-util';
import { PropertyDTO } from '@gen/property/property.dto';

export function getReservationNights(reservation: ReservationDTO): number {
  const { arrival_date, departure_date } = reservation ?? {};
  if (!arrival_date || !departure_date) {
    return 0;
  }

  const nights = PlainDateUtil.daysBetween(
    PlainDateUtil.toPlainDateUseInShared(arrival_date),
    PlainDateUtil.toPlainDateUseInShared(departure_date)
  );
  return nights > 0 ? nights : 0;
}

export function getReservationsNightsSum(reservations: ReservationDTO[]): number {
  return reservations.reduce((sum, reservation) => sum + getReservationNights(reservation), 0);
}

export function isCancelledReservation(reservation: ReservationDTO): boolean {
  return reservation?.beds24_status === Beds24ReservationStatus.CANCELLED;
}

export function isUknownPlatform(reservation: ReservationDTO): boolean {
  return (
    !reservation?.platform?.includes(ReservationPlatform.BOOKING) &&
    !reservation?.platform?.includes(ReservationPlatform.AIRBNB) &&
    !reservation?.platform?.includes(ReservationPlatform.VIRBO) &&
    !reservation?.platform?.includes(ReservationPlatform.NOVATEN)
  );
}

export function isMonthlyTerm(entity: ReservationDTO | PropertyDTO): boolean {
  return entity?.rental_pricing?.terms_type === TermsType.FIXED_MONTH;
}

export function sortPeriodRatesByStartDate(rates: PeriodRateDTO[]): PeriodRateDTO[] {
  return rates?.sort((a, b) =>
    PlainDateUtil.daysBetween(PlainDateUtil.toPlainDateUseInShared(a.start_date), PlainDateUtil.toPlainDateUseInShared(b.start_date))
  );
}

export function setBlockValidity(blockName: string, isValid: boolean, blocks: { name: string; invalid: boolean }[]) {
  const block = blocks.find((b) => b.name === blockName);
  if (block) {
    block.invalid = !isValid;
  }
}
